import React from 'react';
import { CalendarDays } from 'lucide-react';

import PrivateLayout from '../../../layouts/PrivateLayout';
import { useUser } from '../../../../contexts/UserContext';
import EventsTab from './EventsTab';

// Events (Nic 2026-08-23): its own Operations destination — creating and
// managing sign-up events (QR codes, activation), no longer a tab riding
// Lead Handoffs. NB the deliberate split still holds: THIS page manages
// events; the Event Leads page is the worklist of leads that arrived FROM
// an event.
const EventsPage = () => {
  const { hasPermission } = useUser();
  const canManage = hasPermission('leads:manage');
  return (
    <PrivateLayout>
      <div className="w-full">
        <div className="mb-3">
          <h2 className="mb-0 flex items-center gap-2 whitespace-nowrap text-xl font-bold text-slate-800">
            <CalendarDays size={19} className="text-slate-400" />
            Events
          </h2>
          <div className="text-xs text-slate-400">
            Sign-up events and their QR codes
          </div>
        </div>
        <EventsTab canManage={canManage} />
      </div>
    </PrivateLayout>
  );
};

export default EventsPage;
